import type { FC } from "react"

import styles from "./DatasourceConfigTab.module.scss"
import BulkApplyBar from "./bulk-apply-bar/BulkApplyBar"
import DatasourceConfigHeader from "./header/DatasourceConfigHeader"
import DatasourceConfigTable from "./table/DatasourceConfigTable"
import { useDatasourceConfig } from "./useDatasourceConfig"

type DatasourceConfigTabProps = {
	companyId: string
}

const DatasourceConfigTab: FC<DatasourceConfigTabProps> = ({ companyId }) => {
	const {
		salons,
		dataSourceColumns,
		policyOptions,
		statusCounts,
		selectedSalonIds,
		companyLoading,
		columnsLoading,
		updatingGoal,
		handleSelectAll,
		handleSelectSalon,
		handleBulkApply,
		handleUpdateMemo,
		handleCopyPassword,
		isPasswordCopying,
	} = useDatasourceConfig(companyId)

	if (companyLoading || columnsLoading) {
		return (
			<div className={styles.loadingContainer}>
				<div className={styles.loading}>読み込み中...</div>
			</div>
		)
	}

	return (
		<div className={styles.tab}>
			<div className={styles.card}>
				<DatasourceConfigHeader
					totalCount={salons.length}
					statusCounts={statusCounts}
				/>
				{selectedSalonIds.size > 0 && (
					<BulkApplyBar
						selectedCount={selectedSalonIds.size}
						policyOptions={policyOptions}
						onApply={handleBulkApply}
						loading={updatingGoal}
					/>
				)}
				<DatasourceConfigTable
					salons={salons}
					dataSourceColumns={dataSourceColumns}
					policyOptions={policyOptions}
					selectedSalonIds={selectedSalonIds}
					onSelectAll={handleSelectAll}
					onSelectSalon={handleSelectSalon}
					onUpdateMemo={handleUpdateMemo}
					onCopyPassword={handleCopyPassword}
					isPasswordCopying={isPasswordCopying}
				/>
			</div>
		</div>
	)
}

export default DatasourceConfigTab
